import { COUNTRY_ISO2 } from '../geo/geoConstants';

/**
 * Spreadsheet template offered for download before a massive upload. Each
 * country has its own column set, so the link follows the account's country.
 */
export const EXCEL_TEMPLATES = {
  [COUNTRY_ISO2.CL]:
    'https://ninja-hubs-public-prod.s3.us-east-1.amazonaws.com/templates/ninjahubs-template.xlsx',
  [COUNTRY_ISO2.MX]:
    'https://ninja-hubs-public-prod.s3.us-east-1.amazonaws.com/templates/ninjahubs-template-mx.xlsx',
};

/** Tax id label shown in the manual form. */
export const DOCUMENT_LABEL_BY_COUNTRY = {
  [COUNTRY_ISO2.CL]: 'RUT',
  [COUNTRY_ISO2.MX]: 'RFC',
};

/**
 * Columns each template ships with, in sheet order. Every one of them must be
 * present in the uploaded file, even the optional ones — a missing column
 * means the operator is using an outdated template.
 */
export const EXCEL_HEADERS_BY_COUNTRY = {
  [COUNTRY_ISO2.CL]: [
    'Id_referencia',
    'Destinatario',
    'Direccion',
    'Comuna',
    'Region',
    'Metodo de envio',
    'Notas',
    'Rut',
    'Telefono',
    'Correo',
    'Bultos',
    'Tags',
    'Peso',
  ],
  [COUNTRY_ISO2.MX]: [
    'Id_referencia',
    'Destinatario',
    'Pais',
    'Direccion',
    'Postal',
    'Region',
    'Comuna',
    'Colonia',
    'Metodo de envio',
    'Notas',
    'RFC',
    'Telefono',
    'Correo',
    'Bultos',
    'Tags',
    'Peso',
  ],
};

/**
 * Columns that must also carry a value on every row. The rest may be blank:
 * notes, tags, weight, phone, email and the tax id are optional.
 */
export const REQUIRED_ROW_FIELDS_BY_COUNTRY = {
  [COUNTRY_ISO2.CL]: [
    'Id_referencia',
    'Destinatario',
    'Direccion',
    'Comuna',
    'Region',
    'Metodo de envio',
    'Bultos',
  ],
  [COUNTRY_ISO2.MX]: [
    'Id_referencia',
    'Destinatario',
    'Pais',
    'Direccion',
    'Postal',
    'Region',
    'Comuna',
    'Colonia',
    'Metodo de envio',
    'Bultos',
  ],
};

export const ACCEPTED_SHEET_EXTENSIONS = ['.xlsx', '.xls', '.csv'];

export const UPLOAD_MODES = {
  MASSIVE: 'massive',
  MANUAL: 'manual',
};
